import * as React from 'react'

function SvgIconMail(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#icon_mail_svg__clip0)" fill="#fff">
        <path d="M11.11 10.56a1.27 1.27 0 001.77 0L22.57.87a.51.51 0 000-.71.62.62 0 00-.28-.16H1.71a.5.5 0 00-.42.57.47.47 0 00.14.28l9.68 9.71z" />
        <path d="M23.89 1.83a.18.18 0 00-.2 0l-6.2 6.2a.25.25 0 000 .36l5 5a.75.75 0 01-1 1.08l-5-5a.25.25 0 00-.36 0L14 11.6a2.75 2.75 0 01-3.88 0L7.93 9.49a.25.25 0 00-.36 0l-5 5a.75.75 0 01-1.06-1.06l5-5a.25.25 0 000-.36l-6.2-6.2a.18.18 0 00-.2 0A.18.18 0 000 2v12a2 2 0 002 2h20a2 2 0 002-2V2a.18.18 0 00-.11-.17z" />
      </g>
      <defs>
        <clipPath id="icon_mail_svg__clip0">
          <path fill="#fff" d="M0 0h24v16H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgIconMail
